/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { dispatchEvent as o, validatePackage as a, classNames as i } from "@progress/kendo-react-common";
import { packageMetadata as p } from "./package-metadata.mjs";
class h extends e.PureComponent {
  constructor(s) {
    super(s), this.onScroll = (t) => o(this.props.onScroll, t, this, void 0), a(p);
  }
  /**
   * @hidden
   */
  render() {
    const { data: s = [], item: t } = this.props;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: i("k-listview k-d-flex", this.props.className),
        style: this.props.style
      },
      this.props.header ? /* @__PURE__ */ e.createElement(this.props.header, null) : null,
      /* @__PURE__ */ e.createElement("div", { role: "list", className: "k-listview-content", onScroll: this.onScroll }, t && s.map((l, r) => /* @__PURE__ */ e.createElement(t, { dataItem: l, index: r, key: r }))),
      this.props.footer ? /* @__PURE__ */ e.createElement(this.props.footer, null) : null
    );
  }
}
export {
  h as ListView
};
